import { ResetStyle } from './Reset';

export { ResetStyle };
